module.exports = __webpack_public_path__ + "static/media/profile-pic.5844e8eb.png";